
<v-content>
  <v-row wrap class="layout">
    <v-col cols="12">
      <h1 class="display-1">
        {{ $t("DOWNLOAD_HEADER") }}
      </h1>
    </v-col>
    <v-col cols="12" class="downloadContent">
      <div v-html="$t('DOWNLOAD_TEXT')"></div>
    </v-col>
    <v-col cols="12">
      <a :href="`/api/download/${code}/zip`" download>
        <v-btn color="primary">
          <v-icon>photo_library</v-icon>
          {{ $t("DOWNLOAD_BUTTON_ALL") }}
        </v-btn>
      </a>
    </v-col>
  </v-row>
  <v-row wrap class="layout">
    <v-col v-for="image in images" :key="image.id" class="imageFlex">
      <v-card class="imageCard">
        <v-img
            :src="`/api/download/${code}/previewImage/${image.id}/large`"
            class="imagePreview"
            contain
            lazy-src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAN4AAADjCAMAAADdXVr2AAAAA1BMVEX///+nxBvIAAAASElEQVR4nO3BMQEAAADCoPVPbQdvoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOA8W9AAHiq1isAAAAAElFTkSuQmCC"></v-img>
        <v-card-actions class="actions">
          <v-spacer/>
          <a :href="`/api/download/${code}/image/${image.id}`" download>
            <v-btn color="primary">
              <v-icon>photo</v-icon>
              {{ $t("DOWNLOAD_BUTTON") }}
            </v-btn>
          </a>
          <v-spacer/>
        </v-card-actions>

      </v-card>
    </v-col>
  </v-row>
</v-content>

